import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Admin | TRX Auto Sales & Service Inc";
    api.get("/auth/me").then(() => navigate("/admin/dashboard")).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("trx_token", data.access_token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(apiError(err, "Invalid email or password"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-trx-black px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-white/10 bg-card p-10">
        <div className="flex items-center gap-3">
          <span className="font-display text-3xl font-black tracking-tight text-white">TRX</span>
          <span className="text-[10px] font-semibold uppercase tracking-[0.3em] text-zinc-500 leading-tight">
            Admin<br />Portal
          </span>
        </div>
        <p className="mt-6 text-sm text-zinc-500">Sign in to manage inventory and view inquiries.</p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <Input
            type="email"
            required
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="h-13 rounded-none border-white/15 bg-black/40 px-4 py-4 text-sm text-white placeholder:text-zinc-600 focus-visible:ring-trx-blue"
            data-testid="admin-email"
          />
          <Input
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-13 rounded-none border-white/15 bg-black/40 px-4 py-4 text-sm text-white placeholder:text-zinc-600 focus-visible:ring-trx-blue"
            data-testid="admin-password"
          />
          {error && (
            <p className="border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-400" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-3 bg-trx-blue px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-all duration-300 hover:bg-white hover:text-black disabled:opacity-50"
          >
            <Lock className="h-4 w-4" />
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <a href="/" className="mt-8 block text-center text-xs text-zinc-600 transition-colors hover:text-zinc-400">
          ← Back to website
        </a>
      </div>
    </div>
  );
}
